<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="inertia-link"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.show,
                    },
                    {
                        name: $tc('messages.rubrics', 1),
                        href: null,
                    },
                ]"
            />
        </template>

        <form :action="meta.links.update" method="post" @submit.prevent="submit">
            <RubricEdit v-model="form.rubric" :ranges="ranges" />

            <div class="flex justify-end mt-5">
                <AppButton desired-action element="button" type="submit">
                    {{ $t('messages.save') }}
                    <span v-if="form.processing" class="ml-1 btn-spinner"></span>
                </AppButton>
            </div>
        </form>
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import AppButton from '@/components/AppButton.vue';
import GradeTranslator from '@/classes/GradeTranslator.js';
import RubricEdit from '@/Pages/Teacher/Activities/Rubrics/RubricEdit.vue';

export default {
    components: {
        RubricEdit,
        PanelPage,
        AppButton,
    },
    layout: Layout,
    name: 'Show',
    props: ['teacher', 'meta', 'options', 'activity', 'ranges'],
    data() {
        return {
            gradeTranslator: new GradeTranslator(this.ranges),
            form: this.$inertia.form({
                rubric: JSON.parse(JSON.stringify(this.activity.rubric)),
            }),
        };
    },
    methods: {
        submit() {
            this.form.patch(this.meta.links.update);
        },
    },
};
</script>
